import { Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

interface SeparatorProps {}

export const Separator: React.FC<SeparatorProps> = () => {
  return <Box py={Spacing['inline.quarck']} />;
};
